/* ================================================== */
/* BOOTSTRAP SELECT > Init
/* ================================================== */

var $selectpicker;

$(document).ready(function(){

	// Init selectpicker if not keyboard mode
	if (Modernizr.sessionstorage && (!sessionStorage.getItem('whatInput') || sessionStorage.getItem('whatInput') !== 'keyboard')) {

		$selectpicker = $('.selectpicker');

		$selectpicker.selectpicker({
			dropupAuto: false,
			size: 19,
			mobile: (checkMobileDevice() === true) ? true : false,
			selectedTextFormat: 'count > 4',
			maxOptions: 1
		});

		$selectpicker.on('loaded.bs.select', function (event) {
			$selectpicker.parent().find('button').attr('aria-hidden', 'true');
		});

	}

});